(function () {
  'use strict';

  function normalize(value) {
    return (value || '').toString().trim().toLowerCase();
  }

  function valuesMatch(a, b) {
    const left = normalize(a);
    const right = normalize(b);
    return left === right || left.includes(right) || right.includes(left);
  }

  function getArchOptionIndex(options) {
    for (let i = 0; i < options.length; i++) {
      if (normalize(options[i]).includes('arch')) return i;
    }
    return -1;
  }

  function getTreatmentOptionIndex(container, options) {
    const configuredIndex = parseInt(container.dataset.treatmentOptionIndex, 10);
    if (!Number.isNaN(configuredIndex) && configuredIndex >= 0) {
      return configuredIndex;
    }

    const clinicValue = container.dataset.clinicVariantValue;
    const homeValue = container.dataset.homeVariantValue;

    for (let i = 0; i < options.length; i++) {
      if (normalize(options[i]).includes('arch')) continue;
      if (normalize(options[i]).includes('start') && normalize(options[i]).includes('treatment')) {
        return i;
      }
    }

  return -1;
  }

  function getSelectedArchValue(options) {
    const archIndex = getArchOptionIndex(options);
    if (archIndex < 0) return null;

    const archInput = document.querySelector('.arch-buttons input.arch-checkbox:checked');
    if (!archInput) return null;

    const label = archInput.closest('label');
    const text = label ? label.textContent.trim() : '';

    if (text.includes('Upper')) return 'Upper Arch';
    if (text.includes('Lower')) return 'Lower Arch';
    return null;
  }

  function getSelectedOptionValues(container, options) {
    const values = new Array(options.length).fill(null);
    const archIndex = getArchOptionIndex(options);
    const treatmentIndex = getTreatmentOptionIndex(container, options);

    if (archIndex >= 0) {
      values[archIndex] = getSelectedArchValue(options);
    }

    const treatmentInput = container.querySelector('input[name="treatment-start-method"]:checked');
    if (treatmentInput && treatmentIndex >= 0) {
      values[treatmentIndex] = treatmentInput.value;
    }

    return values;
  }

  function findMatchingVariant(variants, optionValues) {
    if (!variants || !variants.length) return null;

    const matched = variants.find(function (variant) {
      return optionValues.every(function (value, index) {
        if (!value) return true;
        const optionKey = 'option' + (index + 1);
        return valuesMatch(variant[optionKey], value);
      });
    });

    return matched || variants.find(function (variant) {
      return variant.available !== false;
    }) || variants[0];
  }

  function updateVariantId(container, variants, options) {
    const optionValues = getSelectedOptionValues(container, options);
    const matchedVariant = findMatchingVariant(variants, optionValues);
    if (!matchedVariant) return;

    document.querySelectorAll('form[action="/cart/add"] input[name="id"], form[action="/cart/add"] select[name="id"]').forEach(function (field) {
      field.value = matchedVariant.id;
      if (matchedVariant.price) {
        field.dataset.varPrice = matchedVariant.price;
      }
    });

    const installmentInput = document.querySelector('#product-form-installment input[name="id"]');
    if (installmentInput) {
      installmentInput.value = matchedVariant.id;
    }

    const mainProductField = document.querySelector('[name="main-product"]');
    if (mainProductField) {
      mainProductField.value = matchedVariant.id;
      mainProductField.dataset.productId = matchedVariant.id;
      if (matchedVariant.price) {
        mainProductField.dataset.productPrice = (matchedVariant.price / 100).toFixed(2);
      }
    }

    updatePartiallyButtonConfig(container, variants);
  }

  function getScanCenterContainer() {
    return document.querySelector('[data-treatment-start]');
  }

  function isClinicScanSelected(container) {
    if (!container || !container.dataset.hasScanCenters) return false;
    const clinicVariantValue = container.dataset.clinicVariantValue;
    const treatmentInput = container.querySelector('input[name="treatment-start-method"]:checked');
    return !!(treatmentInput && valuesMatch(treatmentInput.value, clinicVariantValue));
  }

  // Always read the CURRENT checked radio button live, instead of trusting a
  // separately-synced hidden field. This is what "Treatment Start Method" uses.
  function getTreatmentStartMethodValue(container) {
    if (!container) return null;
    const checked = container.querySelector('input[name="treatment-start-method"]:checked');
    return checked ? checked.value : null;
  }

  function getScanCenterProperties(container) {
    container = container || getScanCenterContainer();
    if (!container) return null;

    const properties = {};

    // Always include the treatment start method, regardless of which option is picked.
    const methodValue = getTreatmentStartMethodValue(container);
    if (methodValue) {
      properties[''] = methodValue;
    }

    if (isClinicScanSelected(container)) {
      const selectedClinic = container.querySelector('[data-scan-center-card].is-selected input[name="selected-scan-center"]')
        || container.querySelector('input[name="selected-scan-center"]:checked');

      if (selectedClinic) {
        properties['Scan Center'] = selectedClinic.dataset.clinicName || selectedClinic.value;
        properties['Clinic Address'] = selectedClinic.dataset.clinicAddress || '';
        properties['Clinic City'] = selectedClinic.dataset.clinicCity || '';
        properties['Digital Scan Price'] = selectedClinic.dataset.clinicPrice || '';
      }
    }

    if (Object.keys(properties).length === 0) return null;
    return properties;
  }

  function updateCartPropertyFields(container, variants) {
    container = container || getScanCenterContainer();
    const form = document.querySelector('.button-container.add-to-card form[action="/cart/add"]');
    if (!form) return;

    const properties = getScanCenterProperties(container);

    const scanFields = form.querySelectorAll('[data-scan-center-cart-property]');
    scanFields.forEach(function (field) {
      const key = field.name.replace('properties[', '').replace(']', '');
      const value = properties ? properties[key] : '';

      if (value) {
        field.value = value;
        field.disabled = false;
      } else {
        field.value = '';
        field.disabled = true;
      }
    });

    // Keep the Treatment Start Method hidden field in sync too (used by native
    // form submission when "home" / non-clinic option is selected).
    const methodField = form.querySelector('[data-treatment-method-property]');
    if (methodField) {
      const methodValue = properties ? properties[''] : '';
      methodField.value = methodValue || '';
      methodField.disabled = false;
    }
  }

  function schedulePartiallyButtonUpdate(container, variants) {
    if (!document.partiallyButtonConfig) return;

    clearTimeout(schedulePartiallyButtonUpdate.timer);
    schedulePartiallyButtonUpdate.timer = setTimeout(function () {
      updatePartiallyButtonConfig(container, variants);
    }, 0);
  }

  function syncScanCenterSelection(container, variants) {
    updateCartPropertyFields(container, variants);
    schedulePartiallyButtonUpdate(container, variants);
  }

  function clearScanCenterSelection(container) {
    container.querySelectorAll('[data-scan-center-card]').forEach(function (card) {
      card.classList.remove('is-selected', 'active');
      const input = card.querySelector('input[type="radio"]');
      if (input) input.checked = false;
    });
  }

  function handleScanCenterCardInteraction(container, card, variants, errorEl) {
    const input = card.querySelector('input[type="radio"]');
    const isSelected = card.classList.contains('is-selected');

    if (isSelected) {
      card.classList.remove('is-selected', 'active');
      if (input) input.checked = false;
      syncScanCenterSelection(container, variants);
      return;
    }

    clearScanCenterSelection(container);
    card.classList.add('is-selected', 'active');
    if (input) input.checked = true;
    syncScanCenterSelection(container, variants);
    if (errorEl) errorEl.classList.add('hidden');
  }

  function validateScanCenterSelection(container) {
    container = container || getScanCenterContainer();
    const errorEl = container?.querySelector('[data-scan-center-error]');

    if (!container || !isClinicScanSelected(container)) {
      if (errorEl) errorEl.classList.add('hidden');
      return true;
    }

    const selectedClinic = container.querySelector('[data-scan-center-card].is-selected input[name="selected-scan-center"]')
      || container.querySelector('input[name="selected-scan-center"]:checked:not([disabled])');
    const visibleSlides = container.querySelectorAll('.scan-center-slide:not(.hidden-by-search)');
    const searchInput = container.querySelector('[data-scan-center-search]');
    const hasSearchQuery = normalize(searchInput ? searchInput.value : '');

    if (hasSearchQuery && visibleSlides.length === 0) {
      if (errorEl) errorEl.classList.add('hidden');
      return false;
    }

    if (!selectedClinic) {
      if (errorEl) errorEl.classList.remove('hidden');
      return false;
    }

    if (errorEl) errorEl.classList.add('hidden');
    return true;
  }

  function updateCartAttributes(properties) {
    if (!properties || Object.keys(properties).length === 0) {
      return Promise.resolve();
    }

    const attributes = {};
    if (properties['Treatment Start Method']) attributes['Treatment Start Method'] = properties['Treatment Start Method'];
    if (properties['Scan Center']) {
      attributes['Scan Center'] = properties['Scan Center'];
      attributes['Clinic Address'] = properties['Clinic Address'] || '';
      attributes['Clinic City'] = properties['Clinic City'] || '';
      attributes['Digital Scan Price'] = properties['Digital Scan Price'] || '';
    }

    if (Object.keys(attributes).length === 0) return Promise.resolve();

    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: attributes })
    });
  }

  function getCurrentVariantId() {
    const form = document.querySelector('.button-container.add-to-card form[action="/cart/add"]');
    if (!form) return null;

    const select = form.querySelector('select[name="id"]');
    if (select && select.value) return select.value;

    const inputs = form.querySelectorAll('input[name="id"]');
    if (inputs.length) return inputs[inputs.length - 1].value;

    return null;
  }

  function updatePartiallyButtonConfig(container, variants) {
    if (!document.partiallyButtonConfig) return;

    const variantId = getCurrentVariantId();
    if (!variantId) return;

    const properties = getScanCenterProperties(container) || {};
    const attributes = window.ScanCenterCart.getCartAttributes();
    const variant = (variants || []).find(function (item) {
      return item.id.toString() === variantId.toString();
    });

    const lineItem = {
      variant_id: variantId.toString(),
      quantity: 1
    };

    if (variant && variant.price) {
      lineItem.price = variant.price / 100;
    }

    if (Object.keys(properties).length > 0) {
      lineItem.properties = properties;
    }

    document.partiallyButtonConfig.items = [lineItem];

    if (attributes && Object.keys(attributes).length > 0) {
      document.partiallyButtonConfig.attributes = attributes;
    } else {
      delete document.partiallyButtonConfig.attributes;
    }

    // Pass scan center / treatment method as order notes so it appears in Partial.ly checkout
    if (Object.keys(properties).length > 0) {
      var noteLines = [];
      if (properties['']) noteLines.push('' + properties['']);
      if (properties['Scan Center']) noteLines.push('Scan Center: ' + properties['Scan Center']);
      if (properties['Clinic Address']) noteLines.push('Address: ' + properties['Clinic Address']);
      if (properties['Digital Scan Price']) noteLines.push('Scan Price: ' + properties['Digital Scan Price']);
      document.partiallyButtonConfig.note = noteLines.join(' | ');
      document.partiallyButtonConfig.customerNote = noteLines.join('\n');
    } else {
      delete document.partiallyButtonConfig.note;
      delete document.partiallyButtonConfig.customerNote;
    }
  }

  function bindSamplePlanButton(container, variants) {
    var btn = document.querySelector('[data-toggle="modal"][data-target="#exampleModalCenter"]');
    if (!btn) return;
    btn.addEventListener('click', function () {
      syncScanCenterSelection(container, variants);
    });
  }

  function bindPaymentPlanCards(container, variants) {
    document.querySelectorAll('.payment-card-select').forEach(function (card) {
      card.addEventListener('click', function () {
        syncScanCenterSelection(container, variants);
      });
    });
  }

  function bindPartiallyCheckout(container, variants) {
    const partialContainer = document.getElementById('partiallyCartButtonContainer');
    if (!partialContainer) return;

    let bypassScanCenterHook = false;

    function patchPartiallyLinkWithExtras() {
      const link = partialContainer.querySelector('a[href*="partial.ly/checkout"]');
      if (!link) return;

      const properties = getScanCenterProperties(container) || {};
      const scanCenterName = properties['Scan Center'];

      try {
        const url = new URL(link.href);
        const originalName = url.searchParams.get('meta[items][0][name]');
        if (!originalName) return;

        const baseName = originalName.split(' — Scan:')[0];

        if (scanCenterName) {
          url.searchParams.set('meta[items][0][name]', baseName + ' — Scan: ' + scanCenterName);
        } else {
          url.searchParams.set('meta[items][0][name]', baseName);
        }

        link.href = url.toString();
      } catch (e) {
        console.error('Failed to patch Partial.ly link:', e);
      }
    }

    function attachPartialHandler() {
      const partialBtn = partialContainer.querySelector('a, button');
      if (!partialBtn || partialBtn.dataset.scanCenterBound === 'true') return;

      partialBtn.dataset.scanCenterBound = 'true';

      partialBtn.addEventListener('click', function (event) {
        if (bypassScanCenterHook) {
          bypassScanCenterHook = false;
          return;
        }

        syncScanCenterSelection(container, variants);

        if (!validateScanCenterSelection(container)) {
          event.preventDefault();
          event.stopImmediatePropagation();
          scrollToScanCenterFeedback(container);
          return false;
        }

        const properties = getScanCenterProperties(container) || {};
        if (Object.keys(properties).length === 0) return;

        const variantId = getCurrentVariantId();
        if (!variantId) return;

        event.preventDefault();
        event.stopImmediatePropagation();

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            items: [{
              id: parseInt(variantId, 10),
              quantity: 1,
              properties: properties
            }]
          })
        })
          .then(function (res) { return res.json(); })
          .then(function () {
            return updateCartAttributes(properties);
          })
          .then(function () {
            updatePartiallyButtonConfig(container, variants);
            patchPartiallyLinkWithExtras();
            bypassScanCenterHook = true;
            partialBtn.click();
          })
          .catch(function (err) {
            console.error('Partial.ly add to cart error:', err);
          });

        return false;
      }, true);
    }

    const observer = new MutationObserver(function () {
      attachPartialHandler();
      patchPartiallyLinkWithExtras();
    });
    observer.observe(partialContainer, { childList: true, subtree: true });
    attachPartialHandler();
    updatePartiallyButtonConfig(container, variants);
    patchPartiallyLinkWithExtras();
  }

  window.ScanCenterCart = {
    getLineItemProperties: function () {
      return getScanCenterProperties() || {};
    },
    getCartAttributes: function () {
      const properties = getScanCenterProperties();
      if (!properties) return null;
      const attributes = {};
      if (properties['']) attributes[''] = properties[''];
      if (properties['Scan Center']) {
        attributes['Scan Center'] = properties['Scan Center'];
        attributes['Clinic Address'] = properties['Clinic Address'] || '';
        attributes['Clinic City'] = properties['Clinic City'] || '';
        attributes['Digital Scan Price'] = properties['Digital Scan Price'] || '';
      }
      return attributes;
    },
    validate: function () {
      return validateScanCenterSelection();
    },
    updateCartPropertyFields: function () {
      updateCartPropertyFields();
    },
    updateCartAttributes: function () {
      return updateCartAttributes(getScanCenterProperties());
    },
    updatePartiallyButtonConfig: function () {
      const container = getScanCenterContainer();
      const variants = JSON.parse(document.querySelector('[data-product-variants-json]')?.textContent || '[]');
      updatePartiallyButtonConfig(container, variants);
    }
  };

  function isMobileViewport() {
    return window.matchMedia('(max-width: 767px)').matches;
  }

  function updateCarouselOrientation(carousel) {
    if (!carousel) return;
    carousel.classList.toggle('is-vertical', isMobileViewport());
    carousel.classList.toggle('is-horizontal', !isMobileViewport());
  }

  function initScanCenterSlider(container) {
    if (!window.jQuery || typeof window.jQuery.fn.slick !== 'function') return;

    const carousel = container.querySelector('[data-scan-center-carousel]');
    if (!carousel || !carousel.classList.contains('scan-center-carousel--slider')) return;

    const slideCount = parseInt(carousel.dataset.slideCount, 10) || carousel.querySelectorAll('.scan-center-slide').length;
    const $carousel = window.jQuery(carousel);
    const $slider = $carousel.find('[data-scan-center-slider]');
    const $nav = $carousel.find('[data-scan-center-nav]');

    if (!$slider.length || slideCount <= 1) {
      if ($nav.length) $nav.addClass('hidden');
      return;
    }

    if ($nav.length) $nav.removeClass('hidden');
    updateCarouselOrientation(carousel);

    if ($slider.hasClass('slick-initialized')) {
      $slider.slick('setPosition');
      return;
    }

    $slider.slick({
      slidesToShow: 2.2,
      slidesToScroll: 1,
      infinite: false,
      arrows: true,
      dots: false,
      adaptiveHeight: false,
      waitForAnimate: false,
      speed: 200,
      touchThreshold: 12,
      swipeToSlide: false,
      prevArrow: $carousel.find('[data-scan-center-prev]'),
      nextArrow: $carousel.find('[data-scan-center-next]'),
      responsive: [
        {
          breakpoint: 768,
          settings: {
            vertical: true,
            verticalSwiping: true,
            slidesToShow: 2.5,
            slidesToScroll: 1,
            infinite: false,
            arrows: true,
            waitForAnimate: false,
            speed: 200,
            touchThreshold: 12,
            swipeToSlide: false,
            prevArrow: $carousel.find('[data-scan-center-prev]'),
            nextArrow: $carousel.find('[data-scan-center-next]')
          }
        }
      ]
    });

    $slider.on('setPosition afterChange', function () {
      updateCarouselOrientation(carousel);
    });

    carousel.dataset.sliderReady = 'true';
  }

  function ensureScanCenterSlider(container) {
    const panel = container.querySelector('[data-scan-center-panel]');
    if (!panel || panel.classList.contains('hidden')) return;

    initScanCenterSlider(container);

    const carousel = container.querySelector('[data-scan-center-carousel]');
    if (!carousel || !window.jQuery) return;

    const $slider = window.jQuery(carousel).find('[data-scan-center-slider]');
    if ($slider.hasClass('slick-initialized')) {
      $slider.slick('setPosition');
    }
  }

  window.ScanCenterSlider = {
    destroy: function (container) {
      if (!container || !window.jQuery) return;
      const carousel = container.querySelector('[data-scan-center-carousel]');
      if (!carousel) return;
      const $slider = window.jQuery(carousel).find('[data-scan-center-slider]');
      if ($slider.hasClass('slick-initialized')) {
        $slider.slick('unslick');
      }
    },
    reinit: function (container) {
      if (!container) return;
      ensureScanCenterSlider(container);
    },
    applyDistanceFilter: function (container) {
      if (!container || !window.jQuery) return;
      const carousel = container.querySelector('[data-scan-center-carousel]');
      if (!carousel) return;
      const $slider = window.jQuery(carousel).find('[data-scan-center-slider]');
      if (!$slider.hasClass('slick-initialized')) return;

      const hiddenCount  = carousel.querySelectorAll('.scan-center-slide.hidden-by-search').length;
      const visibleCount = carousel.querySelectorAll('.scan-center-slide:not(.hidden-by-search)').length;
      const $nav = window.jQuery(carousel).find('[data-scan-center-nav]');

      $slider.slick('slickUnfilter');
      if (hiddenCount > 0 && visibleCount > 0) {
        $slider.slick('slickFilter', '.scan-center-slide:not(.hidden-by-search)');
      }

      $nav.toggleClass('hidden', visibleCount <= 1);
      $slider.slick('setPosition');
    }
  };

  function scrollToScanCenterFeedback(container) {
    const errorEl = container.querySelector('[data-scan-center-error]');
    const noResultsEl = container.querySelector('[data-scan-center-no-results]');

    if (noResultsEl && !noResultsEl.classList.contains('hidden')) {
      noResultsEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return;
    }

    if (errorEl && !errorEl.classList.contains('hidden')) {
      errorEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }

  function switchToHomeVariant(container, variants, options) {
    const homeVariantValue = container.dataset.homeVariantValue;
    const treatmentInputs = container.querySelectorAll('input[name="treatment-start-method"]');
    let homeInput = null;

    treatmentInputs.forEach(function (input) {
      if (valuesMatch(input.value, homeVariantValue)) {
        homeInput = input;
      }
    });

    if (!homeInput) return;

    container.querySelectorAll('.treatment-variant-btn').forEach(function (btn) {
      btn.classList.remove('active');
    });

    const homeLabel = homeInput.closest('.treatment-variant-btn');
    if (homeLabel) homeLabel.classList.add('active');
    homeInput.checked = true;

    toggleScanPanel(container);
    updateVariantId(container, variants, options);
    syncScanCenterSelection(container, variants);

    const noResultsEl = container.querySelector('[data-scan-center-no-results]');
    if (noResultsEl) noResultsEl.classList.add('hidden');

    const errorEl = container.querySelector('[data-scan-center-error]');
    if (errorEl) errorEl.classList.add('hidden');

    const searchInput = container.querySelector('[data-scan-center-search]');
    if (searchInput) searchInput.value = '';
  }

  function toggleScanPanel(container) {
    const panel = container.querySelector('[data-scan-center-panel]');
    if (!panel) return;

    const clinicVariantValue = container.dataset.clinicVariantValue;
    const treatmentInput = container.querySelector('input[name="treatment-start-method"]:checked');
    const isClinicSelected = treatmentInput && valuesMatch(treatmentInput.value, clinicVariantValue);

    panel.classList.toggle('hidden', !isClinicSelected);

    if (isClinicSelected) {
      ensureScanCenterSlider(container);
    }
  }

  function bindArchButtons(container, variants, options) {
    document.querySelectorAll('.arch-buttons .btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        setTimeout(function () {
          updateVariantId(container, variants, options);
        }, 0);
      });
    });

    document.querySelectorAll('.arch-buttons input[type="radio"]').forEach(function (input) {
      input.addEventListener('change', function () {
        updateVariantId(container, variants, options);
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    const container = document.querySelector('[data-treatment-start]');
    const variants = JSON.parse(document.querySelector('[data-product-variants-json]')?.textContent || '[]');
    const options = JSON.parse(document.querySelector('[data-product-options-json]')?.textContent || '[]');
    const cartForm = document.querySelector('.button-container.add-to-card form[action="/cart/add"]');
    const buyButton = document.getElementById('one-time-payment-button');

    bindPartiallyCheckout(container, variants);
    bindPaymentPlanCards(container, variants);
    bindSamplePlanButton(container, variants);

    if (!container) return;

    const errorEl = container.querySelector('[data-scan-center-error]');

    ensureScanCenterSlider(container);
    toggleScanPanel(container);
    updateVariantId(container, variants, options);
    syncScanCenterSelection(container, variants); // syncs Treatment Start Method + Scan Center on load
    bindArchButtons(container, variants, options);

    window.addEventListener('resize', function () {
      const carousel = container.querySelector('[data-scan-center-carousel]');
      if (carousel) updateCarouselOrientation(carousel);
      ensureScanCenterSlider(container);
    });

    container.querySelectorAll('.treatment-variant-btn').forEach(function (label) {
      label.addEventListener('click', function () {
        container.querySelectorAll('.treatment-variant-btn').forEach(function (btn) {
          btn.classList.remove('active');
        });
        label.classList.add('active');
        const input = label.querySelector('input[type="radio"]');
        if (input) input.checked = true;

        toggleScanPanel(container);
        updateVariantId(container, variants, options);
        syncScanCenterSelection(container, variants); // re-syncs Treatment Start Method + Scan Center on every click
        if (errorEl) errorEl.classList.add('hidden');
      });
    });

    const scanPanel = container.querySelector('[data-scan-center-panel]');
    if (scanPanel) {
      scanPanel.addEventListener('mousedown', function (event) {
        if (event.target.closest('[data-scan-center-card]')) {
          event.preventDefault();
        }
      });

      scanPanel.addEventListener('click', function (event) {
        const card = event.target.closest('[data-scan-center-card]');
        if (!card) return;

        event.preventDefault();
        event.stopPropagation();
        handleScanCenterCardInteraction(container, card, variants, errorEl);
      });
    }

    const switchHomeBtn = container.querySelector('[data-scan-center-switch-home]');
    if (switchHomeBtn) {
      switchHomeBtn.addEventListener('click', function () {
        switchToHomeVariant(container, variants, options);
      });
    }

    if (cartForm) {
      cartForm.addEventListener('submit', function (event) {
        syncScanCenterSelection(container, variants);

        if (!validateScanCenterSelection(container)) {
          event.preventDefault();
          scrollToScanCenterFeedback(container);
          return;
        }

        const properties = getScanCenterProperties(container);

        if (properties) {
          const returnInput = cartForm.querySelector('input[name="return_to"]');
          const returnTo = returnInput ? returnInput.value : '/cart';

          event.preventDefault();

          const variantField = cartForm.querySelector('select[name="id"], input[name="id"]');
          const variantId = variantField ? variantField.value : null;
          if (!variantId) return;

          const item = { id: parseInt(variantId, 10), quantity: 1, properties: properties };

          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: [item] })
          })
            .then(function (res) { return res.json(); })
            .then(function () {
              return updateCartAttributes(properties);
            })
            .then(function () {
              window.location.href = returnTo;
            })
            .catch(function (err) {
              console.error('Add to cart error:', err);
            });
        }
      });
    }

    if (buyButton) {
      buyButton.addEventListener('click', function (event) {
        syncScanCenterSelection(container, variants);

        if (!validateScanCenterSelection(container)) {
          event.preventDefault();
          scrollToScanCenterFeedback(container);
        }
      }, true);
    }
  });
})();